import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import GallerySection from "@/components/GallerySection";
import FloorSection from "@/components/FloorSection";
import LocationSection from "@/components/LocationSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#050505]" data-testid="app-root">
        <Header />
        <main>
          <HeroSection />
          <AboutSection />
          <GallerySection />
          <FloorSection />
          <LocationSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
